import { bootstrapApplication } from '@angular/platform-browser';
import { init } from '@sentry/angular';

import { AppConfig } from './app/app.config';
import { App } from './app/components/app/app';
import { Environment } from './environments/environment';

init({
  dsn: 'https://a6412db48284f82b08882d1e096d2653@sentry01.thevillages.com/43',
  enabled: Environment.production,
});

bootstrapApplication(App, AppConfig).catch((err: unknown) => {
  console.error(err);
});
